import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"

export async function deleteGuest(eventVaultId?: number, guestId?: number) {
  if (!eventVaultId)
    throw new Error("Missing Event Vault Id: Unable to call `deleteGuest`.")
  if (!guestId)
    throw new Error("Missing Guest Id: Unable to call `deleteGuest`.")

  const response = await v1.delete<ServerResponseV1<void>>(`/guest/${guestId}`, { params: { eventVaultId } })

  return response.data?.message
}

const DELETE_GUEST_KEY = "deleteGuest"

export function useDeleteGuest(eventVaultId?: MaybeRef<number | undefined>) {
  return useMutation({
    mutationKey: [DELETE_GUEST_KEY, eventVaultId],
    mutationFn: (guestId?: number) => deleteGuest(toValue(eventVaultId), guestId),
  })
}
